/**
 * Reads the `?username=&password=` sign-in prefill (QA and partner links) and
 * removes both params from the address bar right away.
 *
 * This runs at startup rather than in the sign-in page because a visitor who
 * is already signed in never mounts that page, and the plaintext password
 * would otherwise stay in history, bookmarks, Referer headers and telemetry.
 * Like `authTokenFromUrl`, this module has no imports and is imported at the
 * top of `src/index.tsx`, before the router or any telemetry reads the URL.
 */
const url = new URL(window.location.href);

const username = url.searchParams.get("username");
const password = url.searchParams.get("password");

let prefillCredentials = username && password ? { username, password } : null;

/**
 * Returns the captured prefill once and forgets it, so a later sign-in form
 * (e.g. after signing out without a reload) does not show it again.
 */
export const takePrefillCredentials = () => {
    const credentials = prefillCredentials;
    prefillCredentials = null;
    return credentials;
};

if (url.searchParams.has("username") || url.searchParams.has("password")) {
    url.searchParams.delete("username");
    url.searchParams.delete("password");
    window.history.replaceState(window.history.state, "", url.href);
}
